export enum BookingServiceEndpoints {
    BaseUrl = '/v1/booking',
    PostCalculateBookingDetails = '/v1/booking/calculate',
    PostUpdateOccupantDetails = '/v1/booking/dual-occupant',
    CheckBookingProcessedSalesforce = '/v1/booking/{bookingRecordId}/sf/status',
    GetDataForTransfermatePayment = '/v1/booking/{bookingId}/make-payment-advance-fee',
    PostCreateStl = '/v1/booking/stl',
}
